import * as i0 from '@angular/core';
import { model, input, output, computed, inject, DestroyRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { interval, takeWhile, tap, map } from 'rxjs';
import * as i1 from '@digipay/ngx-badge';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
const _c0 = ["*"];
function NgxCountDownComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "span", 3);
    i0.ɵɵtext(5, "\u0631\u0648\u0632");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 4);
    i0.ɵɵtext(7, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 5);
    i0.ɵɵtext(9);
    i0.ɵɵelementStart(10, "span", 3);
    i0.ɵɵtext(11, "\u0633\u0627\u0639\u062A");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 4);
    i0.ɵɵtext(13, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 6);
    i0.ɵɵtext(15);
    i0.ɵɵelementStart(16, "span", 3);
    i0.ɵɵtext(17, "\u062F\u0642\u06CC\u0642\u0647");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 4);
    i0.ɵɵtext(19, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 7);
    i0.ɵɵtext(21);
    i0.ɵɵelementStart(22, "span", 3);
    i0.ɵɵtext(23, "\u062B\u0627\u0646\u06CC\u0647");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(24, "p", 8);
    i0.ɵɵtext(25, " \u062A\u0627 \u0634\u0631\u0648\u0639 \u067E\u0631\u062F\u0627\u062E\u062A \u0627\u0642\u0633\u0627\u0637 \u0628\u0627\u0642\u06CC \u0645\u0627\u0646\u062F\u0647 \u0627\u0633\u062A. ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formattedTime().day, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formattedTime().hour, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formattedTime().minutes, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formattedTime().seconds, " ");
  }
}
function NgxCountDownComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r0.formattedTime().minutes, ":", ctx_r0.formattedTime().seconds, " ");
  }
}
function NgxCountDownComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate3(" ", ctx_r0.formattedTime().hour, ":", ctx_r0.formattedTime().minutes, ":", ctx_r0.formattedTime().seconds, " ");
  }
}
function NgxCountDownComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ngx-badge", 9)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.formattedTime().minutes, ":", ctx_r0.formattedTime().seconds, " ");
  }
}
function NgxCountDownComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
let NgxCountDownComponent = /*#__PURE__*/(() => {
  class NgxCountDownComponent {
    constructor() {
      this.timeInSeconds = model(3600 * 12);
      this.type = input('installment');
      this.finished = output();
      this.day = output();
      this.hour = output();
      this.minutes = output();
      this.seconds = output();
      this.formattedTime = computed(() => this.formatTime(this.timeInSeconds()));
      this.destroyRef = inject(DestroyRef);
      this.timer = interval(1000).pipe(takeWhile(() => this.timeInSeconds() > 0), tap(() => {
        this.timeInSeconds.update(seconds => seconds - 1);
      }), map(() => {
        if (this.timeInSeconds() === 0) {
          this.finished.emit(true);
        }
      }));
      this.timer.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    }
    formatTime(seconds) {
      const d = Math.floor(seconds / (3600 * 24));
      const h = Math.floor(seconds % (3600 * 24) / 3600);
      const m = Math.floor(seconds % 3600 / 60);
      const s = Math.floor(seconds % 60);
      this.day.emit(this.padZero(d));
      this.hour.emit(this.padZero(h));
      this.minutes.emit(this.padZero(m));
      this.seconds.emit(this.padZero(s));
      return {
        day: this.padZero(d),
        hour: this.padZero(h),
        minutes: this.padZero(m),
        seconds: this.padZero(s)
      };
    }
    padZero(value) {
      return value.toString().padStart(2, '0');
    }
    static {
      this.ɵfac = function NgxCountDownComponent_Factory(t) {
        return new (t || NgxCountDownComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxCountDownComponent,
        selectors: [["ngx-count-down"]],
        inputs: {
          timeInSeconds: [i0.ɵɵInputFlags.SignalBased, "timeInSeconds"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"]
        },
        outputs: {
          timeInSeconds: "timeInSecondsChange",
          finished: "finished",
          day: "day",
          hour: "hour",
          minutes: "minutes",
          seconds: "seconds"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 1,
        consts: [[1, "countdown"], [1, "time", "text-onback-brand"], [1, "time-part", "day"], [1, "label"], [1, "colon"], [1, "time-part", "hour"], [1, "time-part", "minute"], [1, "time-part", "seconds"], [1, "description", "text-onback-brand", "c-2", "text-align-center"], ["mode", "fill"]],
        template: function NgxCountDownComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NgxCountDownComponent_Conditional_0_Template, 26, 4, "div", 0)(1, NgxCountDownComponent_Conditional_1_Template, 2, 2)(2, NgxCountDownComponent_Conditional_2_Template, 2, 3)(3, NgxCountDownComponent_Conditional_3_Template, 3, 2)(4, NgxCountDownComponent_Conditional_4_Template, 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(0, ctx.type() === "installment" ? 0 : ctx.type() === "mm:ss" ? 1 : ctx.type() === "hh:mm:ss" ? 2 : ctx.type() === "with-badge" ? 3 : ctx.type() === "custom" ? 4 : -1);
          }
        },
        dependencies: [NgxBadgeModule, i1.NgxBadgeComponent],
        styles: [".countdown[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none}.time[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;margin:0 0 16px}.time-part[_ngcontent-%COMP%]{width:25%;background:#edf4ff;border-radius:8px;padding:8px 4px;font-size:32px;text-align:center;font-weight:500}.label[_ngcontent-%COMP%]{display:block;font-size:8px;margin:4px 0 0}.colon[_ngcontent-%COMP%]{margin:0 4px}.description[_ngcontent-%COMP%]{direction:rtl}"],
        changeDetection: 0
      });
    }
  }
  return NgxCountDownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxCountDownComponent };
